import { createMiddleware } from 'redux-beacon';
import GoogleTagManager from '@redux-beacon/google-tag-manager';

import * as metricsActions from './metrics/actions';
import * as compareActions from './compare/actions';
import * as uiActions from './ui/actions';
import * as authUserActions from './auth/user/actions';

const events = {
  /* metrics */
  [metricsActions.CHANGE_ASSET]: (action) => ({
    event: action.type,
    metrics: {
      asset: action.payload.asset,
    },
  }),
  [metricsActions.CHANGE_METRIC]: (action) => ({
    event: action.type,
    metrics: {
      metricCode: action.payload.metricCode,
    },
  }),
  [metricsActions.DOWNLOAD_METRIC_DATA]: (action) => ({
    event: action.type,
    metrics: {
      format: action.payload.format,
    },
  }),
  [metricsActions.DOWNLOAD_IMAGE]: (action) => ({
    event: action.type,
  }),

  /* compare */
  [compareActions.CHANGE_ASSET]: (action) => ({
    event: action.type,
    compare: {
      asset: action.payload.asset,
    },
  }),
  [compareActions.CHANGE_METRIC]: (action) => ({
    event: action.type,
    compare: {
      metricCode: action.payload.metricCode,
    },
  }),
  [compareActions.CHANGE_SCALE]: (action) => ({
    event: action.type,
    compare: {
      scale: action.payload.value,
    },
  }),
  [compareActions.CHANGE_MOVING_AVERAGE]: (action) => ({
    event: action.type,
    compare: {
      movingAverage: action.payload.value,
    },
  }),
  [compareActions.CHANGE_CURRENCY]: (action) => ({
    event: action.type,
    compare: {
      currency: action.payload.value,
    },
  }),
  [compareActions.DOWNLOAD_IMAGE]: (action) => ({
    event: action.type,
  }),

  /* ui */
  [uiActions.TOGGLE_SIDEBAR]: (action) => ({
    event: action.type,
  }),
  [uiActions.SHOW_SIDEBAR]: (action) => ({
    event: action.type,
  }),
  [uiActions.HIDE_SIDEBAR]: (action) => ({
    event: action.type,
  }),
  [uiActions.SHOW_MOBILE_NAV]: (action) => ({
    event: action.type,
  }),
  [uiActions.HIDE_MOBILE_NAV]: (action) => ({
    event: action.type,
  }),

  /* user */
  [authUserActions.GET_INFO_FULFILLED]: (action) => ({
    event: action.type,
    user: {
      plan: action.payload.plan,
    },
  }),
};

const gtm = GoogleTagManager();
const gtmMiddleware = createMiddleware(events, gtm);

export default gtmMiddleware;
